import type { Schema } from "normalizr";
import type { Dispatch } from "redux";

export const START_REQUEST = "restful_api/START_REQUEST";
export const UPDATE_ENTITIES = "restful_api/UPDATE_ENTITIES";
export const REPLACE = "restful_api/REPLACE";
export const CLEAR_ENTITY = "restful_api/CLEAR_ENTITY";
export const ENTITY_ACTIONS = [START_REQUEST, UPDATE_ENTITIES, REPLACE, CLEAR_ENTITY];
export type RequestParams = {
  url: string;
  method?: "get" | "post" | "put" | "head" | "options" | "delete";
  body?: any;
  responseSchema?: Schema;
  responseKey?: string;
};
type RequestCallback = (response: any, dispatch: Dispatch<any>, request: RequestParams) => void;
export type RequestCallbacks = {
  onSuccess?: RequestCallback;
  onFailure?: RequestCallback;
  replace?: boolean;
};
export type StartRequestAction = {
  type: typeof START_REQUEST;
  payload: RequestParams;
  meta: RequestCallbacks;
};
export type UpdateEntitiesAction<T> = {
  type: typeof UPDATE_ENTITIES;
  payload: {
    entities: Record<string, T>;
  };
};
export type replaceEntitiesAction<T> = {
  type: typeof REPLACE;
  payload: {
    entities: Record<string, T>;
  };
};
export type Action<T> = StartRequestAction | UpdateEntitiesAction<T> | replaceEntitiesAction<T>;
export const request = (params: RequestParams, meta: RequestCallbacks): StartRequestAction => ({
  type: START_REQUEST,
  payload: params,
  meta,
});
export const updateEntities = (entities: unknown) => ({
  type: UPDATE_ENTITIES,
  payload: entities,
});
export const replace = (entities: unknown) => ({
  type: REPLACE,
  payload: entities,
});
export const clearEntity = (collection: string) => ({
  type: CLEAR_ENTITY,
  payload: {
    collection,
  },
});
